/* Puptein v11: product card Subscribe / One-time toggle */
(function () {
  // Swap button label + disclosure when the shopper picks an option
  document.addEventListener('change', function (e) {
    var r = e.target.closest && e.target.closest('[data-card-plan]');
    if (!r || r.type !== 'radio') return;
    var f = r.form;
    if (!f) return;
    f.querySelectorAll('.cplan').forEach(function (l) { l.classList.toggle('is-on', l.contains(r)); });
    var lbl = f.querySelector('[data-card-label]');
    if (lbl && r.dataset.label) lbl.textContent = r.dataset.label;
    var note = f.querySelector('[data-card-note]');
    if (note) note.hidden = !r.value;
    var freq = f.querySelector('[data-card-freqwrap]');
    if (freq) freq.hidden = !r.value;
  });
  // Product card: frequency dropdown sets which plan the Subscribe option uses
  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('[data-card-freq]');
    if (!sel) return;
    var f = sel.form;
    var sub = f && f.querySelector('input[data-card-plan][value]:not([value=""])');
    if (!sub) return;
    sub.value = sel.value;
    if (!sub.checked) { sub.checked = true; sub.dispatchEvent(new Event('change', { bubbles: true })); }
  });
  // Product page: frequency chips inside the Subscribe & save option
  document.addEventListener('click', function (e) {
    var chip = e.target.closest && e.target.closest('[data-plan-chip]');
    if (!chip) return;
    e.preventDefault();
    var box = chip.closest('.po__opt');
    var radio = box && box.querySelector('[data-sub-radio]');
    if (!radio) return;
    // A real tap means the shopper chose this frequency: the pouch planner must not override it
    if (e.isTrusted) { var fm = chip.closest('form'); if (fm) fm.dataset.planManual = '1'; }
    box.querySelectorAll('[data-plan-chip]').forEach(function (c) {
      var on = c === chip;
      c.classList.toggle('is-on', on);
      c.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    radio.value = chip.dataset.planChip;
    radio.checked = true;
    radio.dispatchEvent(new Event('change', { bubbles: true }));
  });
  // Pouch planner: dogs by size -> daily scoops -> pouches per delivery + best frequency
  function ppDays(name) {
    var m = /(\d+)\s*(day|week|month)/i.exec(name || '');
    if (!m) return 0;
    var n = parseInt(m[1], 10), u = m[2].toLowerCase();
    return u === 'day' ? n : u === 'week' ? n * 7 : n * 30;
  }
  function ppPlural(n, one, many) { return n + ' ' + (n === 1 ? one : many); }
  var ppTimer;
  function ppMoney(c) { var d = Math.round(c) / 100; return '$' + (d % 1 ? d.toFixed(2) : d.toFixed(0)); }
  function ppRun(pp, quiet) {
    var form = pp.closest('form');
    if (!form) return;
    var per = parseFloat(pp.dataset.perPouch) || 90;
    var dogs = 0, scoops = 0, parts = [];
    pp.querySelectorAll('[data-pp-count]').forEach(function (o) {
      var c = parseInt(o.textContent, 10) || 0;
      var row = o.closest('.pp__row'); if (row) row.classList.toggle('is-on', c > 0);
      dogs += c; scoops += c * (parseFloat(o.dataset.scoops) || 0);
      if (c) parts.push(c + ' x ' + o.dataset.label);
    });
    var out = pp.querySelector('[data-pp-result]'), sum = pp.querySelector('[data-pp-summary]');
    pp.classList.toggle('is-multi', dogs > 1);
    if (!dogs || !scoops) { out.innerHTML = 'Add at least one dog.'; var mEl0 = pp.querySelector('[data-pp-mini]'); if (mEl0) mEl0.textContent = 'Add each pup so we send enough'; return; }

    var radio = form.querySelector('[data-sub-radio]');
    var oneTime = form.querySelector('input[name="purchase_option"][value=""]');
    var isSub = !!radio && (radio.checked || !oneTime);
    var dogTxt = ppPlural(dogs, 'dog', 'dogs');
    var best, freq = '', html, summary, mini = '';

    if (isSub) {
      var plans = [];
      form.querySelectorAll('[data-plan-chip]').forEach(function (c) {
        plans.push({ el: c, id: c.dataset.planChip, name: c.dataset.planName, days: ppDays(c.dataset.planName) });
      });
      if (!plans.length) {
        var nm = (form.querySelector('.po__sub') || {}).textContent || '';
        plans.push({ el: null, id: radio.value, name: nm.trim(), days: ppDays(nm) });
      }
      plans = plans.filter(function (p) { return p.days > 0; });
      if (!plans.length) return;
      // Fewest pouches that cover the gap between deliveries; pick the closest fit
      plans.forEach(function (p) {
        var need = scoops * p.days;
        var q = Math.max(1, Math.ceil(need / per - 0.05));
        var fit = q * per / need;
        if (!best || fit < best.fit - 0.01 || (Math.abs(fit - best.fit) <= 0.01 && p.days > best.days)) best = { plan: p, q: q, fit: fit, days: p.days };
      });
      // If the shopper picked a frequency themselves, keep it and size the quantity to that plan instead
      var manual = form.dataset.planManual && plans.filter(function (p) { return p.el && p.el.classList.contains('is-on'); })[0];
      if (manual) {
        var mNeed = scoops * manual.days, mQ = Math.max(1, Math.ceil(mNeed / per - 0.05));
        best = { plan: manual, q: mQ, fit: mQ * per / mNeed, days: manual.days };
      } else if (best.plan.el && !best.plan.el.classList.contains('is-on')) best.plan.el.click();
      freq = best.plan.name.replace(/^delivery\s+/i, '').toLowerCase();
      mini = ppPlural(best.q, 'pouch', 'pouches') + ' ' + freq + ' \u00b7 ' + dogTxt;
      html = '<strong>' + ppPlural(best.q, 'pouch', 'pouches') + ' ' + freq + '</strong>' +
        'About ' + ppPlural(Math.round(scoops * 10) / 10, 'scoop', 'scoops') + ' a day for ' + dogTxt + ', so each delivery lasts about ' + Math.floor(best.q * per / scoops) + ' days.';
      html += best.fit > 1.6
        ? '<small>That is more than they need between deliveries, so skip one whenever the pantry is full. You can skip anytime from your account.</small>'
        : '<small>We set your quantity and frequency. You can change either one.</small>';
      summary = dogs > 1 ? dogTxt + ': ' + ppPlural(best.q, 'pouch', 'pouches') + ' ' + freq : 'Feeding more than one? Add them below.';
    } else {
      // One-time: enough pouches for about N days, never a giant first order
      var target = parseFloat(pp.dataset.onetimeDays) || 42;
      var q1 = Math.max(1, Math.ceil(scoops * target / per - 0.05));
      best = { q: q1, plan: null };
      var lasts1 = Math.floor(q1 * per / scoops);
      mini = ppPlural(q1, 'pouch', 'pouches') + ' \u00b7 about ' + lasts1 + ' days \u00b7 ' + dogTxt;
      html = '<strong>' + ppPlural(q1, 'pouch', 'pouches') + '</strong>' +
        'About ' + ppPlural(Math.round(scoops * 10) / 10, 'scoop', 'scoops') + ' a day for ' + dogTxt + ', so ' + (q1 === 1 ? 'it lasts' : 'they last') + ' about ' + lasts1 + ' days.';
      var price = parseFloat(pp.dataset.price), subPrice = parseFloat(pp.dataset.subPrice);
      if (radio && subPrice && price > subPrice) {
        var save = (price - subPrice) * q1;
        html += '<button type="button" class="pp__switch" data-pp-switch>Subscribe instead, save ' + ppMoney(save) + '</button>' +
          '<small>Delivered on repeat so you never run out. Skip or cancel anytime.</small>';
      } else {
        html += '<small>We set your quantity. You can change it.</small>';
      }
      summary = dogs > 1 ? dogTxt + ': ' + ppPlural(q1, 'pouch', 'pouches') + ', about ' + lasts1 + ' days' : 'Feeding more than one? Add them below.';
    }

    var qty = form.querySelector('[data-qty-input]');
    if (qty) { qty.value = best.q; qty.dispatchEvent(new Event('input', { bubbles: true })); qty.dispatchEvent(new Event('change', { bubbles: true })); }
    // Only tag the cart line when it's for more than one dog, so single-dog orders stay one clean line
    var prop = form.querySelector('input[name="properties[For]"]');
    if (dogs > 1) {
      if (!prop) { prop = document.createElement('input'); prop.type = 'hidden'; prop.name = 'properties[For]'; form.appendChild(prop); }
      prop.value = dogTxt;
    } else if (prop) { prop.remove(); }
    out.innerHTML = html;
    pp.classList.add('is-set');
    if (sum) sum.textContent = summary;
    var miniEl = pp.querySelector('[data-pp-mini]'); if (miniEl && mini) miniEl.textContent = mini;

    if (quiet) return;
    clearTimeout(ppTimer);
    ppTimer = setTimeout(function () {
      var props = { dogs: dogs, dog_sizes: parts.join(', '), scoops_per_day: scoops, pouches: best.q, purchase: isSub ? 'subscription' : 'one-time', frequency: best.plan ? best.plan.name : '', page: location.pathname };
      try { if (window.klaviyo && window.klaviyo.track) window.klaviyo.track('Used Pouch Planner', props); } catch (e) {}
      try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('used_pouch_planner', props); } catch (e) {}
    }, 1200);
  }
  // Show the planner result for the default dog on load, so the pouch math is visible before any taps
  function ppInit() { document.querySelectorAll('[data-pouch-planner]').forEach(function (pp) { ppRun(pp, true); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ppInit); else ppInit();
  // "Subscribe instead" inside the planner result
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-pp-switch]');
    if (!b) return;
    e.preventDefault();
    var pp = b.closest('[data-pouch-planner]'), form = pp && pp.closest('form');
    var radio = form && form.querySelector('[data-sub-radio]');
    if (!radio) return;
    radio.checked = true;
    radio.dispatchEvent(new Event('change', { bubbles: true }));
    ppRun(pp);
  });
  // Planner collapse toggle (compact PDP layout)
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-pp-toggle]');
    if (!b) return;
    var pp = b.closest('[data-pouch-planner]');
    if (!pp) return;
    var open = pp.classList.toggle('is-open');
    b.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
  // Recalculate when the shopper switches between Subscribe and One-time
  document.addEventListener('change', function (e) {
    var r = e.target;
    if (!r || r.name !== 'purchase_option' || !r.form) return;
    var pp = r.form.querySelector('[data-pouch-planner].is-set');
    if (pp) setTimeout(function () { ppRun(pp, true); }, 0);
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-pp-step]');
    if (!b) return;
    e.preventDefault();
    var o = b.parentNode.querySelector('[data-pp-count]');
    var n = Math.min(9, Math.max(0, (parseInt(o.textContent, 10) || 0) + parseInt(b.dataset.ppStep, 10)));
    o.textContent = n;
    ppRun(b.closest('[data-pouch-planner]'));
  });
  // Notify me (snippets/notify-me.liquid): subscribe to the Klaviyo list + log which product they want.
  // Straight to Klaviyo's client API, so it works even without the Klaviyo app embed.
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches('[data-notify-me]')) return;
    e.preventDefault();
    var input = f.querySelector('input[type="email"]'), email = (input.value || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { input.focus(); f.classList.add('is-err'); return; }
    f.classList.remove('is-err');
    var btn = f.querySelector('button'); if (btn) btn.disabled = true;
    var d = f.dataset;
    var url = function (path) { return 'https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(d.key); };
    var post = function (path, body) {
      return fetch(url(path), { method: 'POST', keepalive: true, headers: { 'Content-Type': 'application/json', revision: '2024-10-15' }, body: JSON.stringify(body) })
        .then(function (r) { if (!r.ok && r.status !== 202) throw new Error('klaviyo ' + r.status); return r; });
    };
    var props = { product: d.product, product_id: d.productId, handle: d.handle, variant_id: d.variant, reason: d.reason, page: location.href };
    var sub = { data: { type: 'subscription', attributes: { custom_source: 'Notify me: ' + d.product, profile: { data: { type: 'profile', attributes: { email: email } } } }, relationships: { list: { data: { type: 'list', id: d.list } } } } };
    var evt = { data: { type: 'event', attributes: { properties: props, metric: { data: { type: 'metric', attributes: { name: 'Requested Launch Notification' } } }, profile: { data: { type: 'profile', attributes: { email: email, properties: { last_notify_request: d.product } } } } } } };
    post('subscriptions', sub).catch(function () {})
      .then(function () { return post('events', evt); })
      .then(function () {
        f.classList.add('is-done');
        try { if (window.klaviyo && window.klaviyo.identify) window.klaviyo.identify({ email: email }); } catch (err) {}
        try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('requested_launch_notification', props); } catch (err) {}
      })
      .catch(function () {
        if (btn) btn.disabled = false;
        f.classList.add('is-err');
        var t = f.querySelector('.nm__fine'); if (t) t.textContent = 'Something went wrong. Please try again.';
      });
  });
  // Product cards link to #notify-<id>: focus the email field on arrival
  if (/^#notify-\d+$/.test(location.hash)) {
    var nmT = document.querySelector(location.hash);
    if (nmT) setTimeout(function () { nmT.scrollIntoView({ block: 'center' }); var i = nmT.querySelector('input[type="email"]'); if (i) i.focus({ preventScroll: true }); }, 300);
  }
  // Subscription apps can inject their own selling_plan field into every product form.
  // On our cards, only the shopper's choice counts, so drop anything else before the cart add runs.
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches('.card__form, .cu__form')) return;
    f.querySelectorAll('[name="selling_plan"]:not([data-card-plan])').forEach(function (i) { i.remove(); });
  }, true);
})();